import React from "react";

const CloudPage = () => {
  return <div>CloudPage</div>;
};

export default CloudPage;
